import request from '../utils/request.js';

/** CMS 固定域名（你提供的地址） */
export const CMS_BASE_URL = 'http://192.168.66.62:72/proxy';

/** 通知公告站点 ID */
export const NOTICE_SITE_ID = '865091000430661';

/** 获取公告栏目内容列表 */
export function fetchNoticeList(siteId = NOTICE_SITE_ID) {
  return request({
    baseURL: CMS_BASE_URL,
    url: '/cms/content/selectListAll',
    method: 'get',
    params: { siteId },
    timeout: 15000,
  });
}

/** 获取公告文章详情 */
export function fetchNoticeDetail(catalogId, contentId) {
  return request({
    baseURL: CMS_BASE_URL,
    url: `/cms/content/contentInit/${catalogId}/article/${contentId}`,
    method: 'get',
    timeout: 20000,
  });
}
